import Image from "next/image";
import React from "react";
import Fancybox from "../Fancybox";
import Remote from "../LoaderRemote";

const Photos = ({ data }) => {
  return (
    <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 gap-4 mb-8">
      {data.map((item, key) => (
        <Fancybox options={{ infinite: false }} key={key}>
          <div
            className="rounded-md overflow-hidden relative h-24 ml:h-52"
            data-fancybox="gallery"
            data-src={process.env.NEXT_PUBLIC_CDN + "/uploads/" + item.filename}
          >
            <Image
              className="cursor-pointer"
              src={item.filename}
              objectFit="cover"
              layout="fill"
              alt=""
              sizes="(max-width: 768px) 60vw,
              (max-width: 1200px) 25vw,
              25vw"
              loader={Remote}
            ></Image>
          </div>
        </Fancybox>
      ))}
    </div>
  );
};

export default Photos;
